import React from 'react';
import Component from '@vfuk/core-small-picker';
const SmallPicker = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SmallPicker;
